const groupPrefix = createApiRoute(ApiModule.DEMAND_PLANNING, ApiDataModel.PRODUCTION_ORDERS)

export const apiProductionOrders = {
	fetchProductionOrders: async (
		from?: Date,
		to?: Date,
		page: number = 1,
		perPage: number = DEFAULT_PAGE_SIZE,
		sort: Record<string, EApiSortType> = DEFAULT_PRODUCTION_ORDER_SORT,
	) => {
		const { data, meta } = await apiCommon<IProductionOrderSummary[]>(`${groupPrefix}`, {
			method: 'GET',
			...createQuery({ page, perPage }, null, sort, {
				from: from ? dateToFilterFormat(from) : undefined,
				to: to ? dateToFilterFormat(to) : undefined,
			}),
		})

		return { data: data ? data.map(d => ProductionOrderSummary(d)) : [], meta }
	},

	fetchProductionOrderReference: async (reference: string): Promise<IProductionOrderDetailsModel | null> => {
		const { data } = await apiCommon<IProductionOrderDetails>(`${groupPrefix}/${reference}`, {
			method: 'GET',
		})

		return data ? ProductionOrderDetails(data) : null
	},
}
